import React, { useEffect } from 'react';
import { Select } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanies } from '../actions/companyActions';

const CompanySelect = ({ value, onChange, width = '200px', ...props }) => {
  const dispatch = useDispatch();
  const { companies } = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  return (
    <Select width={width} value={value} onChange={(e) => onChange(e.target.value)} {...props}>
      <option value="">Select Company</option>
      {companies.map((comp) => (
        <option key={comp._id} value={comp._id}>
          {comp.name}
        </option>
      ))}
    </Select>
  );
};

export default CompanySelect;
